import * as Atom from 'effect/unstable/reactivity/Atom'

import { TechnicalBrowserLayer } from '#di/browser/browser.layer.ts'
import { appMemoMap } from '#runtime/shared.memo-map.ts'

export const createAtomRuntime = Atom.context({ memoMap: appMemoMap })
createAtomRuntime.addGlobalLayer(TechnicalBrowserLayer)
